
import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";
import { browserSentryEnvSchema } from "../shared/schemas/sentryStartupEnv";

export const initSentry = () => {
  const env = browserSentryEnvSchema.parse({
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_VERCEL_GIT_COMMIT_SHA: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA,
  });
  if (!env.VITE_SENTRY_DSN) return;

  const release = env.VITE_VERCEL_GIT_COMMIT_SHA;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
    environment: import.meta.env.MODE,
    // An explicit undefined release overwrites the id injected by sentryVitePlugin.
    ...(release ? { release } : {}),
    beforeSend(event) {
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === "ChunkLoadError" || error?.value?.includes("Loading chunk")) {
          return null;
        }
      }
      return event;
    },
  });
};
